'use client';

import Script from 'next/script';

import { getENV } from '../../utils/env';

type LocalAdScriptsProps = {
    onDone: () => void;
};

export const LocalAdLegacy = ({ onDone }: LocalAdScriptsProps) => {
    const accessToken = getENV('NEXT_PUBLIC_FLIPP_ACCESS_TOKEN');
    const merchantId = getENV('NEXT_PUBLIC_FLIPP_MERCHANT_ID');
    const merchantName = getENV('NEXT_PUBLIC_FLIPP_MERCHANT_NAME');

    return (
        <>
            <Script
                onLoad={onDone}
                onError={onDone}
                id="flipp-storefront-script"
                src={`https://aq.flippenterprise.net/${merchantId}/iframe.js`}
            />
            <Script strategy="lazyOnload" id="flipp">
                {`var flippContainer = document.querySelector("#flipp-container");
                var storefront = new Flipp.Storefront({
                    accessToken: "${accessToken}",
                    merchantId: "${merchantId}",
                    merchantNameIdentifier: "${merchantName}",
                    locale: "en-CA"
                });
                storefront.renderStorefront(flippContainer);`}
            </Script>
        </>
    );
};
